import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { REQUEST_STEPS } from '../../../enum-request-steps';
import { MarketPlaceQuoteRequestService } from '../../../../../../services/market-place-quote-request-service/market-place-quote-request.service';
import { Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../../../../services/config-service/config.service';
import { LoginService } from 'src/app/services/login-service/login.service';
import { draftQuoteRequest } from 'src/app/services/market-place-quote-request-service/draft-quote-request.service';
import { MixpanelService } from '../../../../../../services/mixpanel-service/mixpanel.service';
@Component({
  selector: 'app-hopper-cart-options',
  templateUrl: './hopper-cart-options.component.html',
  styleUrls: ['../../mechanical-options.component.scss'],
})
export class HopperCartOptionsComponent implements OnInit {
  hopperCartOptions: any;
  objHopperCartOptions: any;
  quoteRequest: any;
  private config: any = null;
  coveredHopperForm = new FormGroup({
    'lining-requirements': new FormControl(null, [Validators.required]),
    'vibrator-brackets': new FormControl(null, [Validators.required]),
    selected: new FormControl(true),
  });

  formSubsription: Subscription;

  constructor(
    private quoteRequestService: MarketPlaceQuoteRequestService,
    private httpClient: HttpClient,
    private draftQuoteService: draftQuoteRequest,
    private mixpanelService: MixpanelService,
    private loginService: LoginService
  ) {
    const strConfig = localStorage.getItem('config-service');
    if (strConfig) {
      this.config = JSON.parse(strConfig);
    }

    this.quoteRequestService.quoteRequest$.subscribe((value) => {
      this.quoteRequest = value;
      this.objHopperCartOptions = value['mechanical-options']['covered-hopper'];
      this.getOptions();
    });

    // Update values on form change. Needed to save changes in case of previous breadcrumb navigation
    this.formSubsription = this.coveredHopperForm.valueChanges.subscribe(() => {
      this.quoteRequest['mechanical-options']['covered-hopper'] =
        this.createSubmittedObj();
    });
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.subscribeToFormControlChanges();
  }

  private subscribeToFormControlChanges(): void {
    const formControls = this.coveredHopperForm.controls;

    Object.keys(formControls).forEach((controlName) => {
      formControls[controlName].valueChanges.subscribe((value) => {
        if (value) {
          this.trackFormControlChange(controlName, value);
        }
      });
    });
  }

  private trackFormControlChange(controlName: string, value: any): void {
    let eventName = '';
    let eventDisplayName = '';
    let eventDefinition = '';
    let parentEvent = '';
    let subParentEvent = '';

    switch (controlName) {
      case 'lining-requirements':
        eventName = 'What are your lining requirements?';
        eventDisplayName = value.map((item: any) => item.name).join(', ');
        eventDefinition = `User changed the value of lining requirements'`;
        parentEvent = 'Begin Quote';
        subParentEvent = 'Mechanical Options';
        break;
      case 'vibrator-brackets':
        eventName = 'Do you need vibrator brackets?';
        eventDisplayName = value ? 'Yes' : 'No';
        eventDefinition = `User changed the value of vibrator brackets`;
        parentEvent = 'Begin Quote';
        subParentEvent = 'Mechanical Options';
        break;
    }

    if (eventName !== '') {
      this.mixpanelService.track({
        eventName,
        eventDisplayName,
        kpi: 'User Engagement',
        trigger: 'On Input Change',
        eventDefinition,
        propertyType: 'Event Property',
        propertyDefinition: controlName,
        additionalProperties: {
          newValue: value,
          parentEvent,
          subParentEvent,
        },
      });
    }
  }

  getOptions(): any {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    this.httpClient
      .post(this.config.leaseMechOptionsURL, {}, { headers: headers })
      .subscribe((data: any) => {
        this.hopperCartOptions = data['mechanical-options']['covered-hopper'];
        this.setHopperForm();
      });
  }

  setHopperForm() {
    this.coveredHopperForm.patchValue(this.objHopperCartOptions);

    if (this.coveredHopperForm.value['lining-requirements'] === '') {
      this.coveredHopperForm
        .get('lining-requirements')
        ?.setValue([this.hopperCartOptions['lining-requirements'][0]]);
    }

    if (this.coveredHopperForm.value['vibrator-brackets'] === '') {
      this.coveredHopperForm
        .get('vibrator-brackets')
        ?.setValue(this.hopperCartOptions['vibrator-brackets'][0]);
    } else {
      const vb = this.hopperCartOptions['vibrator-brackets'].filter(
        (item: any) =>
          item.id == this.objHopperCartOptions['vibrator-brackets'].id
      );
      this.coveredHopperForm.get('vibrator-brackets')?.setValue(vb[0]);
    }
  }

  createSubmittedObj() {
    const obj = this.coveredHopperForm.value;
    this.quoteRequest['mechanical-options']['isValid'] =
      this.coveredHopperForm.valid;
    return obj;
  }

  next() {
    // TODO => you should submit the values by calling setQuoteRequest in the below line
    this.quoteRequest['mechanical-options']['covered-hopper'] =
      this.createSubmittedObj();
    this.quoteRequestService.setQuoteRequest(this.quoteRequest);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.LEASING_OPTIONS);
    this.draftQuoteService.saveDraftQuation(REQUEST_STEPS.LEASING_OPTIONS);
  }

  back() {
    this.quoteRequest['mechanical-options']['covered-hopper'] =
      this.createSubmittedObj();
    this.quoteRequestService.setQuoteRequest(this.quoteRequest);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.SELECTION);
  }
}
